<template>
  <div>
    <div class="d-flex justify-content-between">
      <h4>Посетить</h4>
      <b-button variant="outline-primary" @click="addClicked">Добавить</b-button>
    </div>
    <b-form class="search-form mt-3" @submit.prevent="searchPlaces">
      <b-input-group class="search-control">
        <b-form-input v-model.trim="search" placeholder="Поиск по названию" />
        <b-input-group-append>
          <b-button type="submit" variant="outline-primary">Найти</b-button>
          <b-button v-if="search" variant="outline-secondary" @click="clearSearch">
            Очистить
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-select
        v-model="publishedFilter"
        class="filter-control"
        :options="publishedFilterOptions"
        @change="applyFilters"
      />
      <b-form-select
        v-model="homepageFilter"
        class="filter-control"
        :options="homepageFilterOptions"
        @change="applyFilters"
      />
    </b-form>
    <list-skeleton v-if="loading" :columns="7" />
    <b-table
      v-else
      class="places-table mt-3"
      :fields="fields"
      :items="list"
      @row-clicked="(row) => rowClicked(row)"
      tbody-tr-class="pointer"
    >
      <template #cell(published)="{ value }">
        <b-checkbox :checked="value" @click.native.prevent.stop disabled />
      </template>
      <template #cell(show_on_homepage)="{ value }">
        <b-checkbox :checked="value" @click.native.prevent.stop disabled />
      </template>
      <template #cell(actions)="{ value, item }">
        <div class="table-actions">
          <button
            type="button"
            class="action-button"
            title="QR-код"
            aria-label="QR-код"
            @click.stop="onShowQrCode(item)"
          >
            <b-icon class="action-icon" icon="upc-scan" />
            <span class="action-label">QR-код</span>
          </button>
          <button
            type="button"
            class="action-button action-edit"
            title="Изменить"
            aria-label="Изменить"
            @click.stop="rowClicked(item)"
          >
            <b-icon class="action-icon" icon="pen" />
            <span class="action-label">Изменить</span>
          </button>
          <button
            type="button"
            class="action-button action-delete"
            title="Удалить"
            aria-label="Удалить"
            @click.stop="deleteClicked(item, $event)"
          >
            <b-icon class="action-icon" icon="trash2" />
            <span class="action-label">Удалить</span>
          </button>
        </div>
      </template>
      <template #cell(description)="{ value }">
        <div class="restricted-height">{{ value }}</div>
      </template>
    </b-table>
    <div class="d-flex justify-content-center">
      <b-pagination
        class="m-auto"
        v-model="currentPage"
        :disabled="loading"
        :total-rows="total"
        per-page="25"
      />
    </div>
    <ModalQR ref="ModalQR"></ModalQR>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ModalQR from '@/components/modals/ModalQR.vue';
import ListSkeleton from '@/components/ListSkeleton.vue';

import { Place } from '@/request';

export default {
  name: 'Places',
  components: {
    ModalQR,
    ListSkeleton,
  },
  computed: {
    ...mapState('placeTypes', ['placeTypes']),
  },
  data() {
    return {
      list: [],
      loading: true,
      fields: [
        { key: 'title', label: 'Название', thStyle: { width: '15%' } },
        {
          key: 'place_type_id',
          label: 'Тип',
          formatter: this.formatPlaceType,
          thStyle: { width: '10%' },
        },
        {
          key: 'address',
          label: 'Адрес',
          thStyle: { width: '14%' },
          thClass: 'places-secondary-column',
          tdClass: 'places-secondary-column',
        },
        {
          key: 'description',
          label: 'Описание',
          thStyle: { width: '25%' },
          thClass: 'places-secondary-column',
          tdClass: 'description-column places-secondary-column',
        },
        { key: 'published', label: 'Опубликовано', thStyle: { width: '10%' } },
        { key: 'show_on_homepage', label: 'На главной', thStyle: { width: '9%' } },
        { key: 'actions', label: '', thStyle: { width: '17%' } },
      ],
      currentPage: 1,
      total: 0,
      search: '',
      publishedFilter: null,
      homepageFilter: null,
      publishedFilterOptions: [
        { value: null, text: 'Опубликовано: все' },
        { value: 1, text: 'Опубликовано: да' },
        { value: 0, text: 'Опубликовано: нет' },
      ],
      homepageFilterOptions: [
        { value: null, text: 'На главной: все' },
        { value: 1, text: 'На главной: да' },
        { value: 0, text: 'На главной: нет' },
      ],
    };
  },
  beforeMount() {
    this.ActionGetPlaceTypes();
  },
  mounted() {
    this.loadPlaces(this.currentPage);
  },
  methods: {
    ...mapActions('placeTypes', ['ActionGetPlaceTypes']),
    async loadPlaces(page) {
      this.loading = true;
      try {
        const { data, total } = await Place.getPlaces({
          page,
          search: this.search || undefined,
          filters: this.getFilters(),
        });
        this.list = data;
        this.total = total;
      } catch (e) {
        this.$bvToast.toast(e.message, { variant: 'danger' });
      } finally {
        this.loading = false;
      }
    },
    addClicked() {
      this.$router.push({ name: 'NewPlace' });
    },
    searchPlaces() {
      if (this.currentPage === 1) {
        this.loadPlaces(1);
      } else {
        this.currentPage = 1;
      }
    },
    clearSearch() {
      this.search = '';
      this.searchPlaces();
    },
    applyFilters() {
      this.searchPlaces();
    },
    getFilters() {
      const filters = { place_type: 'travel' };
      if (this.publishedFilter !== null) filters.published = this.publishedFilter;
      if (this.homepageFilter !== null) filters.show_on_homepage = this.homepageFilter;
      return filters;
    },
    rowClicked(row, event = undefined) {
      event?.stopPropagation();

      this.$router.push({ name: 'EditPlace', params: { id: row.id } });
    },
    async deleteClicked(row, event) {
      event?.stopPropagation();

      const userAgreed = await this.$bvModal.msgBoxConfirm(
        `Вы действительно хотите удалить место: ${row.title}?`,
        {
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          cancelVariant: 'outline-secondary',
        },
      );

      if (!userAgreed) {
        return;
      }

      try {
        await Place.deletePlace(row.id);
        this.$bvToast.toast('Место удалено', { variant: 'success' });
        await this.loadPlaces();
      } catch (e) {
        this.$bvToast.toast(e.message, { variant: 'danger' });
      }
    },
    formatPlaceType(placeId) {
      return this.placeTypes.find(({ id }) => id === placeId)?.title;
    },
    onShowQrCode(item) {
      this.$refs.ModalQR.show('place', item);
    },
  },
  watch: {
    currentPage(newVal) {
      this.loadPlaces(newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.restricted-height {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.search-control {
  min-width: 320px;
  flex: 1 1 420px;
}

.filter-control {
  min-width: 225px;
  flex: 0 0 225px;
}
</style>
